<template>
  <section class="w-full py-10 md:py-14">
    <div class="container mx-auto px-4 md:px-8">
      <div class="mb-6 flex items-end justify-between gap-3">
        <h2 class="text-2xl md:text-3xl font-bold">{{ title }}</h2>
        <NuxtLink
          to="/catalog"
          class="text-sm underline hover:opacity-80 shrink-0"
        >
          Дивитись всі
        </NuxtLink>
      </div>

      <CatalogProductGrid
        :items="items"
        :loading="loading"
        :skeleton-count="skeletonCount"
        density="roomy"
        empty-text="Поки немає новинок."
      />
    </div>
  </section>
</template>

<script setup lang="ts">
/* ====================================================================
 *  Блок «Новинки» на головній. REFACTOR_PLAN п.9б.
 *
 *  До 9б компонент сам ходив у Firestore з браузера (запит по товарах +
 *  читання сабколекції варіантів на КОЖЕН товар), і робив це в
 *  onMounted. Оскільки сторінка ще й була загорнута в <ClientOnly>, у
 *  SWR-кеш головної лягала порожня оболонка: заміряно на проді — 0
 *  посилань на товари в сирому HTML.
 *
 *  Тепер компонент нічого не завантажує. Дані бере сторінка
 *  (pages/index.vue) з /api/catalog?preset=new-arrivals на сервері, а
 *  тут лишилась сама вітрина. Стан помилки теж зник: раніше сюди
 *  друкувався сирий e.message від Firestore, чого на головній сторінці
 *  магазину бути не повинно. Збій даних тепер виглядає як порожній блок,
 *  а сторінка тихо пробує ще раз із клієнта.
 * ==================================================================== */
import type { GridItem } from "~/composables/catalog/gridItems";
import { NEW_ARRIVALS_SIZE } from "~/composables/catalog/catalogFilter";

withDefaults(
  defineProps<{
    items?: GridItem[];
    loading?: boolean;
    title?: string;
    /** Скільки плейсхолдерів малювати, поки даних немає. */
    skeletonCount?: number;
  }>(),
  {
    items: () => [],
    loading: false,
    title: "Новинки",
    skeletonCount: NEW_ARRIVALS_SIZE,
  },
);
</script>
